import {
  getChartData,
  getBenchmarkCohortData,
  getSegmentDashboardData
} from "@/api/dashboard";

export default {
  async getChartData({ commit, state }) {
    const response = await getChartData(state.queryData);
    commit("setChartData", response);
  },
  async getBenchmarkCohortData({ commit }) {
    // console.log("HERE");
    const response = await getBenchmarkCohortData();
    commit("setBenchmarkCohortData", response);
  },
  async getSegmentDashboardData({ commit }) {
    const response = await getSegmentDashboardData();
    commit("setSegmentDashboardData", response);
  }
};
